import React, { useEffect, useState, useRef } from 'react';
import moment, { Moment } from 'moment';
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { formElementBaseBgColor } from 'assets/jss/material-dashboard-pro-react';

interface TimerProps {
	onResend: () => void;
	otpLabels: { [key: string]: any };
}

const styles = (theme: any) => ({
	resendButton: {
		fontFamily: theme.fontFamily.albert.regular,
		color: formElementBaseBgColor,
		border: 'none',
		padding: 0,
		textTransform: 'none',
		'&:hover': {
			backgroundColor: 'transparent',
		},
	},
	otpWrapper: {
		gap: '0.5rem',
	},
});
// @ts-ignore
const useStyles = makeStyles(styles);

const TimerWithResend = ({ onResend, otpLabels }: TimerProps) => {
	const classes = useStyles();
	const [endTime, setEndTime] = useState<Moment>(moment().add(otpLabels.otpTimer, 's'));
	const [time, setTime] = useState<string>('');
	const timer = useRef<ReturnType<typeof setInterval> | null>(null);

	const tick = () => {
		const now = moment();
		const diff = moment.duration(endTime.diff(now));

		const minutesLeft = diff.minutes();
		const secondsLeft = diff.seconds();

		if (diff.asSeconds() <= 1) {
			if (timer.current) {
				clearInterval(timer.current);
			}
			setTime('');
		} else {
			setTime(`${minutesLeft}:${secondsLeft < 10 ? '0' : ''}${secondsLeft}`);
		}
	};

	useEffect(() => {
		tick();
		timer.current = setInterval(() => tick(), 1000);
		return () => {
			if (timer.current) {
				clearInterval(timer.current);
			}
		};
	}, []);

	const handleResend = () => {
		setEndTime(moment().add(otpLabels.otpTimer, 's'));
		onResend();
	};

	return (
		<Grid container className={classes.otpWrapper}>
			<span>{otpLabels?.heading}</span>
			{time ? (
				<span>
					{otpLabels?.resendIn} <span data-testid="time">{time}</span>
				</span>
			) : (
				<Button className={classes.resendButton} onClick={handleResend}>
					{otpLabels?.resend}
				</Button>
			)}
		</Grid>
	);
};

export default TimerWithResend;
